import { ManOutlined, WomanOutlined } from '@ant-design/icons';
import React, { CSSProperties } from 'react';
import { User } from '@/models/user';

export type Props = {
  gender: User['gender'];
  className?: string;
  style?: CSSProperties;
};

const UserGender: React.FC<Props> = ({ gender, className = '', style = {} }: Props) => {
  return (
    <>
      <span style={style} className={className}>
        {gender === 1 && <ManOutlined style={{ color: '#1c99d4', fontSize: 16 }} />}
        {gender === 2 && <WomanOutlined style={{ color: '#eb2f96', fontSize: 16 }} />}
      </span>
    </>
  );
};

export default UserGender;
